import {Tabs} from "antd";
import React from "react";
import CompanyInfoSettings from "./CompanyInfoSettings";
import OTPPage from "./OTPPage"

const GeneralSettings = (props)=>{
    const tabItems = [
        {
            label: `Company Info`,
            key: 'company',
            children: <CompanyInfoSettings />,
        },
        {
            label: `One Time Password`,
            key: 'otp',
            children: <OTPPage />,
        },
    ]
    return <Tabs
        tabPosition={'left'}
        items={tabItems}
    />
}

export default GeneralSettings;